import React, {Fragment} from "react";
import { connect } from "react-redux";

import LookFooter from "./lookFooter";
import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../../core/constants";
import LookMainSections from "./lookMainSections";
import LookMainSectionsMobile from "./lookMainSectionsMobile";
import LookMobile from "./lookMobile";

const LookMain = (props) => {

  const {lookOpened, lookExpanded, windowHeight, windowWidth, moreInfoOpened, lookActiveCategory, isMobile, introStep,
    hideYourListButton, lookOverlayOpened} = props;

  let lm_styles = {};
  if (lookExpanded) {
    lm_styles.width = isMobile ? windowWidth - 144 : windowWidth / 2 // 144 is 72 from the left and 72 from the right
  } else if (!isMobile && (moreInfoOpened === "main")) {
    lm_styles.width = 320 * 3
  }

  // const sectionHeight = isMobile
  //   ? windowHeight - 64 // 64(footer height)
  //   : windowHeight - 144 // 144 - is 40(top distance) + 40(bottom distance) + 64(footer height)

  // let featureHeight = 684;
  // if (lookActiveFeature) {
  //   const colorOptions = getFeatureOptions(lookActiveFeature, filterGroups);
  //   if (colorOptions && colorOptions.length) {
  //     featureHeight = 788;
  //   }
  // }

  if (lookOpened && !isMobile) {
    const featureHeight = 748; // always same size (feature height)
    const fullScreenHeight = windowHeight - 80; // 40(top distance) + 40(bottom distance)
    lm_styles.height = fullScreenHeight <= featureHeight ? fullScreenHeight : featureHeight;
    if (hideYourListButton) {
      lm_styles.height += 64;
    }
  }

  // const layout = getCurrentLayout();

  return (
    <Fragment>
      <div style={isMobile ? null : lm_styles}
           className={"lm"
             + (lookExpanded ? " lm--expanded" : "")
             + ((lookOverlayOpened === LOOK_OVERLAYS.aiPanel) ? " opacity-0 visibility-hidden" : "")
             + (hideYourListButton ? " lm--no-footer" : "")
             + (introStep !== LOOK_INTRO_STEPS.welcome ? " lm--mat-transition" : "")
             + ((introStep === LOOK_INTRO_STEPS.review && !isMobile) ? " lm--on-top" : "")}>
        {isMobile
          ? <LookMainSectionsMobile/>
          : (
            <div className={"lm-wrapper" + (lookActiveCategory ? " lm-wrapper--active" : "") + (lookOpened ? " lm-wrapper--opened" : "")}>
              <LookMainSections sectionStyles={lm_styles}/>
            </div>
          )}
        {isMobile || hideYourListButton ? null : <LookFooter/>}
      </div>
      {isMobile ? <LookMobile/> : null}
    </Fragment>
  )
};


const mapStateToProps = (store) => {
  const {hideYourListButton} = store.fabricatorState.settings;
  const {windowWidth, windowHeight, isMobile} = store.serverState;
  const {lookOpened, lookExpanded, lookActiveCategory, moreInfoOpened, introStep, lookOverlayOpened} = store.lookState;

  return {
    isMobile,
    lookOpened,
    lookExpanded,
    windowWidth,
    windowHeight,
    lookActiveCategory,
    moreInfoOpened,
    introStep,
    lookOverlayOpened,
    hideYourListButton,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookMain)
